// src/components/forms/order/OrderShippingInfo.tsx
// Componente para información de envío del pedido

import React from 'react'
import { ShippingCostInput } from '../shared'
import type { OrderData } from '../../../types/orderFormTypes'
import { transportadora } from '../../../assets/data/arrays'
import { Input, Select } from '../../ui'
import { FormField } from '../../ui/Form'
import SectionTitle from '../../ui/SectionTitle'
import { TruckIcon } from '@heroicons/react/24/outline'

interface OrderShippingInfoProps {
  formData: OrderData
  mode: 'view' | 'edit' | 'create'
  costoEnvio: string
  onCostoEnvioChange: (value: string) => void
  onInputChange: (section: keyof OrderData, field: string, value: any) => void
}

export const OrderShippingInfo: React.FC<OrderShippingInfoProps> = ({
  formData,
  mode,
  costoEnvio,
  onCostoEnvioChange,
  onInputChange
}) => {
  const destinoPedido = formData.extraDetails?.destino_pedido === 'metropolitana' 
    ? 'Area Metropolitana' 
    : 'Nacional'

  return (
    <div className="bg-white rounded-lg shadow-sm p-6 mb-4">
      <SectionTitle icon={TruckIcon}>Información de Envío</SectionTitle>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Transportadora */}
        <FormField label="Transportadora">
          <Select
            value={formData.extraDetails?.transportadora || ''}
            onChange={(e) => onInputChange('extraDetails', 'transportadora', e.target.value)}
            disabled={mode === 'view'}
            options={[
              { value: '', label: 'Seleccione' },
              ...transportadora.map((trans) => ({
                value: trans.value,
                label: trans.label
              }))
            ]}
            placeholder="Seleccione"
            mode={mode}
          />
        </FormField>

        {/* Guía */}
        <FormField label="Guía">
          <Input
            type="text"
            value={formData.guia || ''}
            onChange={(e) => {
              const value = e.target.value.replace(/\s/g, '')
              onInputChange('guia', '', value)
            }}
            placeholder="Ingrese número de guía"
            readOnly={mode === 'view'}
            mode={mode}
          />
        </FormField>

        {/* Destino del pedido */}
        <FormField label="Destino del pedido">
          <Input
            type="text"
            value={destinoPedido}
            readOnly
            mode={mode}
          />
        </FormField>

        {/* Costo de Envío */}
        <ShippingCostInput
          value={costoEnvio}
          onChange={(value) => {
            onCostoEnvioChange(value)
            onInputChange('extraDetails', 'costo_envio', value)
          }}
          mode={mode}
        />

        {/* Campos adicionales solo en modo edit/create */}
        {mode !== 'create' && (
          <>
            {/* Estado de envío */}
            <FormField label="Estado de envío">
              <Input
                type="text"
                value={formData.extraDetails?.estado_envio || ''}
                onChange={(e) => onInputChange('extraDetails', 'estado_envio', e.target.value)}
                placeholder="Sin estado"
                readOnly
                disabled={mode === 'view'}
                mode={mode}
              />
            </FormField>

            {/* Valor liquidado */}
            <FormField label="Valor liquidado">
              <Input
                type="number"
                value={formData.extraDetails?.valor_liquidado || ''}
                onChange={(e) => onInputChange('extraDetails', 'valor_liquidado', e.target.value)}
                placeholder="0.00"
                readOnly
                disabled={mode === 'view'}
                mode={mode}
              />
            </FormField>

            {/* Servicio transportadora */}
            <FormField label="Servicio transportadora">
              <Input
                type="number"
                value={formData.extraDetails?.servicio_transportadora || ''}
                onChange={(e) => onInputChange('extraDetails', 'servicio_transportadora', e.target.value)}
                placeholder=""
                readOnly
                disabled={mode === 'view'}
                mode={mode}
              />
            </FormField>
          </>
        )}
      </div>
    </div>
  )
}
